import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  button: {
    flex: 1,
    paddingVertical: theme.spacing[5],
    paddingHorizontal: theme.spacing[4],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    justifyContent: 'center',
    alignItems: 'center',

    variants: {
      state: {
        selected: {
          borderColor: colors.borderSelected,
          backgroundColor: colors.backgroundBrand,
        },
        disabled: {
          opacity: 0.4,
          backgroundColor: colors.backgroundL1,
          borderColor: colors.borderSubtle,
        },
      },
    },
  },
}));
